import { z } from 'zod';

export const revenueExpenseReportSchema = z.object({});

export type EditPrintTemplateTableType = object;

export const editPrintTemPlateSchema = z.object({});

export type EditPrintTemplateFormValues = z.infer<typeof editPrintTemPlateSchema>;

export const formSchema = z.object({
  ngay_ct: z.string().min(1, 'Ngày chứng từ là bắt buộc'),
  unit_id: z.number().optional(),

  // id_goc: z.number().optional().nullable(),
  // ma_kh: z.string().optional(),
  // ma_nt: z.string().optional(),
  ten_kh_thue: z.string().min(1, 'Tên khách hàng trên hóa đơn là bắt buộc'),
  ong_ba: z.string().min(1, 'Họ tên người đại diện là bắt buộc'),
  ma_so_thue: z.string().min(1, 'Mã số thuế là bắt buộc'),
  dia_chi: z.string().min(1, 'Địa chỉ là bắt buộc'),
  dien_thoai: z.string().min(1, 'Điện thoại là bắt buộc'),
  e_mail: z.string().email('Email không hợp lệ').min(1, 'Email là bắt buộc'),

  tknh: z.string().min(1, 'Tài khoản ngân hàng là bắt buộc'),
  ten_nh: z.string().min(1, 'Tên ngân hàng là bắt buộc'),

  noi_dung: z.string().min(1, 'Nội dung là bắt buộc'),
  van_ban_thoa_thuan: z.string().min(1, 'Văn bản thỏa thuận là bắt buộc'),
  ngay_thoa_thuan: z.string().min(1, 'Ngày thỏa thuận là bắt buộc'),

  // Status (optional with default)
  status: z.string().optional().default('1')
});

export type FormValues = z.infer<typeof formSchema>;

export const searchSchema = z.object({
  ngay_ct: z.string().optional(),
  ten_kh_thue: z.string().optional(),
  ma_so_thue: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
